import React, { ReactElement } from 'react'
import classNames from 'classnames'

interface PriceProps {
  priceLine1: string | undefined
  priceLine2: string | undefined
  small: boolean | undefined
}

export default function Price(props: PriceProps): ReactElement {
  return (
    <div
      className={classNames(
        'absolute right-0 z-10 rounded-l-md bg-rgba-white-88 pl-2 pr-2 text-right',
        {
          'pt-0.5': props.small,
          'pb-0.5 pt-1': !props.small,
          'top-2': props.priceLine1,
          'top-5': !props.priceLine1,
        },
      )}
    >
      <div
        className={classNames('-mb-0 font-regular', {
          'text-[12px]': !props.small,
          'mt-0.5 text-[11px] leading-3': props.small,
        })}
      >
        {props.priceLine1}
      </div>
      <div
        className={classNames('-mt-0.5 font-semibold', {
          'text-2xl': !props.small,
          'text-sm leading-[22px]': props.small,
        })}
      >
        {props.priceLine2}
      </div>
    </div>
  )
}
